import emailjs from '@emailjs/browser';

// EmailJS configuration
// You'll need to set these up at https://www.emailjs.com/
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || '';
const EMAILJS_TEMPLATE_ID_ADMIN = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_ADMIN || '';
const EMAILJS_TEMPLATE_ID_USER = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_USER || '';
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '';

// Initialize EmailJS
if (EMAILJS_PUBLIC_KEY) {
  emailjs.init(EMAILJS_PUBLIC_KEY);
}

/**
 * Send notification email to admin (zealshah73@gmail.com with CC to mananshah3654@gmail.com)
 */
export const sendAdminNotification = async (formData) => {
  if (!EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID_ADMIN || !EMAILJS_PUBLIC_KEY) {
    console.warn('EmailJS not configured. Email not sent.');
    return false;
  }

  try {
    const templateParams = {
      company_name: formData.companyName,
      website: formData.website,
      competitor: formData.competitor,
      user_email: formData.email,
    };

    await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID_ADMIN,
      templateParams
    );

    console.log('Admin notification email sent successfully');
    return true;
  } catch (error) {
    console.error('Failed to send admin notification email:', error);
    return false;
  }
};

/**
 * Send confirmation email to the user
 */
export const sendUserConfirmation = async (formData) => {
  if (!EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID_USER || !EMAILJS_PUBLIC_KEY) {
    console.warn('EmailJS not configured. Email not sent.');
    return false;
  }

  try {
    const templateParams = {
      to_email: formData.email,
      company_name: formData.companyName,
      subject: 'Thank You for Your Submission - whyAIrecommend',
    };

    await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID_USER,
      templateParams
    );

    console.log('User confirmation email sent successfully');
    return true;
  } catch (error) {
    console.error('Failed to send user confirmation email:', error);
    return false;
  }
};

/**
 * Check if EmailJS is configured
 */
export const isEmailJSConfigured = () => {
  return !!(
    EMAILJS_SERVICE_ID &&
    EMAILJS_TEMPLATE_ID_ADMIN &&
    EMAILJS_TEMPLATE_ID_USER &&
    EMAILJS_PUBLIC_KEY
  );
};

/**
 * Submit contact form and send emails
 * Always returns success - never throws errors
 */
export const submitContactForm = async (formData) => {
  // Always return success immediately - show thank you message right away
  // Emails are sent in the background and don't block the UI
  
  // Try to send emails in the background (non-blocking)
  if (isEmailJSConfigured()) {
    // Send emails asynchronously without blocking
    Promise.allSettled([
      sendAdminNotification(formData).catch(err => console.warn('Admin email failed:', err)),
      sendUserConfirmation(formData).catch(err => console.warn('User email failed:', err)),
    ]).then(([adminResult, userResult]) => {
      const adminSent = adminResult.status === 'fulfilled' && adminResult.value === true;
      const userSent = userResult.status === 'fulfilled' && userResult.value === true;
      
      if (!adminSent && !userSent) {
        console.warn('Emails were not sent. Check EmailJS configuration.');
      }
    });
  } else {
    console.warn('EmailJS not configured. Form submitted but emails will not be sent.');
    console.warn('To enable emails, set up EmailJS and add environment variables. See console for details.');
  }

  // Always return success immediately
  return {
    success: true,
    message: 'Form submitted successfully',
  };
};

